import { h, Component } from 'preact';
import { getCurrentUserConsent, runWhenDidomiIsReady } from './didomi.service';
import { DIDOMI_EVENTS_TO_MONITOR, DIDOMI_EVENT_CONSENT_CHANGED, IUserConsent } from './didomi.types';
import { registerMiniFooterEvent } from '../../../common/monitoring';
import { widgetConfiguration } from '@sgwt-widget/core';

interface ICookiesConsentProps {
  emitUserConsentEvent: (eventName: string, consents: IUserConsent[]) => void;
}

const DIDOMI_SCRIPT_HOM = 'widgets/sgwt-mini-footer/didomi/didomi-script.v2.min.js';
const DIDOMI_SCRIPT_PROD = 'widgets/sgwt-mini-footer/didomi/didomi-script.min.js';
const CDN_SHARED_DOMAIN = 'https://shared.sgmarkets.com';
const CDN_AZURE_DEV_DOMAIN = 'https://sgwt-widgets-dev.sgmarkets.com';
const CDN_AZURE_PRD_DOMAIN = 'https://sgwt-cdn-widgets.sgmarkets.com';

export class CookiesConsent extends Component<ICookiesConsentProps> {
  componentDidMount() {
    // Configuration, cf. https://console.didomi.io/societe-generale-cib/notices/NQ268Jbg/embed
    (window as any).didomiConfig = {
      languages: {
        // 'de', 'es', 'it', 'ru' not validated by JUR.
        // 'ja', 'zh' not supported by Didomi.
        enabled: ['en', 'fr'],
        default: 'en'
      },
      // TODO Remove error "Didomi - IDs configuration for the IAB stacks should be a non-empty array"
      app: {
        vendors: {
          iab: {
            stacks: {
              ids: [1]
            }
          }
        }
      }
    };
    // Listen to Didomi events
    runWhenDidomiIsReady(() => {
      this.listenToDidomiEvents();
      this.retrieveCurrentUserConsent();
    });
  }

  private listenToDidomiEvents = () => {
    const listeners = (window as any).didomiEventListeners;
    if (!!listeners) {
      // Event related to consent modification...
      listeners.push({
        event: DIDOMI_EVENT_CONSENT_CHANGED,
        listener: this.consentChanged
      });

      // Events we just want to monitor in our activity logs...
      for (const evt of DIDOMI_EVENTS_TO_MONITOR) {
        listeners.push({
          event: evt,
          listener: () => registerMiniFooterEvent(`cookies-consent.didomi.${evt}`)
        });
      }
    }
  }

  private consentChanged = () => {
    const consents = getCurrentUserConsent();
    this.props.emitUserConsentEvent('user-consent-changed', consents || []);
    registerMiniFooterEvent('cookies-consent.consent-changed');
  }

  private retrieveCurrentUserConsent = () => {
    const consents = getCurrentUserConsent();
    this.props.emitUserConsentEvent('current-user-consent', consents || []);
  }

  // Check on which CDN the Widget JS was loaded, to either user the Azure or Shared CDN to load the Didomi JS script.
  private getCdnUrl() {
    // We search for the <script> tag that loaded the widget...
    const scriptTag = document.querySelector(`script[src*="sgwt-mini-footer.js"]`);
    const env = widgetConfiguration().environment;
    const isProd = !env || env.toLowerCase() === 'production' || env.toLowerCase() === 'prod';
    const didomiScript = isProd ? DIDOMI_SCRIPT_PROD : DIDOMI_SCRIPT_HOM;
    if (scriptTag) {
      const src = (scriptTag as HTMLScriptElement).src;
      // and check if it was loaded from one Azure CDN...
      if (src.indexOf(CDN_AZURE_PRD_DOMAIN) > -1 || src.indexOf(CDN_AZURE_DEV_DOMAIN) > -1) {
        return `${CDN_AZURE_PRD_DOMAIN}/${didomiScript}`;
      }
    }
    return `${CDN_SHARED_DOMAIN}/${didomiScript}`;
  }

  render() {
    const cdnUrl = this.getCdnUrl();
    return (
      <script type="text/javascript" src={cdnUrl}></script>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-mini-footer/components/cookies-consent/CookiesConsent.tsx